import React from 'react';
import { PageSection, ListFieldSection } from '../Layout';
import { Field, TextInput, Dropdown, Message } from '../Core';
import { Link } from 'Components/Core';

const logEventLevelOptions = [
  { label: 'Debug', value: 1 },
  { label: 'Information', value: 2 },
  { label: 'Warning', value: 3 },
  { label: 'Error', value: 4 },
];

const LoggingAdmin = () => (
  <PageSection>
    <ListFieldSection single>
      <Message warning>
        Changes to logging settings will require a <Link to="/admin/restart">QESTNet restart.</Link>
      </Message>
      <Field label="Log File Path" input={<TextInput />} name="syncModel.LogFilePath" />
      <Field
        label="Log Event Level"
        input={<Dropdown />}
        name="syncModel.LogEventLevel"
        options={logEventLevelOptions}
        simpleValue
      />
    </ListFieldSection>
  </PageSection>
);

export default LoggingAdmin;
export { LoggingAdmin };
